import React from 'react';
import PropTypes from 'prop-types';

import UserPresenter from '../../../presenters/UserPresenter';
import Modal from '../../../components/Modal';

const UserSelect = (props) => {
  const { modalOpen, closeModal, users, onSelect } = props;

  const handleChange = (user) => {
    onSelect(user);
    closeModal();
  };

  return (
    <div>
      <Modal
        title="Select User"
        onClose={() => closeModal()}
        isModalOpen={modalOpen}
      >
        <table className="tables">
          <thead>
            <tr>
              <th>Auth0 Id</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr onClick={() => handleChange(user)} key={user.id}>
                <td>{user.auth0Id}</td>
                <td>{user.email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </div>
  );
};

export default UserSelect;

UserSelect.propTypes = {
  users: PropTypes.arrayOf(UserPresenter.shape()),
  modalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
};

UserSelect.defaultProps = {
  users: [],
};
